<template>
    <a-modal
        centered
        title="来源渠道"
        :visible="visible"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="540"
        :after-close="after_close"
    >
        <template v-if="basic_data_source.length">
          <a-card
              class="project"
              size="small"
          >
            <a-checkable-tag
                class="r-checkbox checkbox-tag"
                v-for="i in basic_data_source[0]['children']"
                :checked="source_info != null && source_info.id === i.id"
                @change="on_click(i)"
            >{{i.title}}</a-checkable-tag>
          </a-card>
<!--        <a-card
            class="project"
            :title="basic_data_source[0].title"
            size="small"
        >
            <a-checkable-tag
                class="r-checkbox checkbox-tag"
                v-for="i in basic_data_source[0]['children']"
                :checked="source_info != null && source_info.id === i.id"
                @change="on_click(i)"
            >{{i.title}}</a-checkable-tag>
        </a-card>-->

<!--        <a-card
                class="project"
                :title="basic_data_source[1].title"
                size="small"
        >
            <a-checkable-tag
                    class="r-checkbox checkbox-tag"
                    v-for="i in basic_data_source[1]['children']"
                    :checked="promote_source_info != null && promote_source_info.id === i.id"
                    @change="on_click2(i)"
            >{{i.title}}</a-checkable-tag>
        </a-card>-->
        </template>

        <a-empty v-else description="暂未设置任何来源渠道，请联系管理员或者前往系统设置创建。" />
    </a-modal>
</template>
<script>
import basic_data from "../../mixins/basic_data";
export default {
    mixins: [basic_data],
    props: {
        visible: false,
        callback: null,
        source_id: null,
        promote_source_id: null,
    },
    data() {
        return {
            source_info: undefined,
            promote_source_info: undefined
        };
    },
    watch: {
        visible(e) {
            if (e) {
                if(this.source_id){
                    let select_source = this.basic_data_source[0]['children'].find(x => x.id === this.source_id)
                    if(select_source != null) this.source_info = select_source
                }
                if(this.promote_source_id){
                    let select_source = this.basic_data_source[1]['children'].find(x => x.id === this.promote_source_id)
                    if(select_source != null) this.promote_source_info = select_source
                }
            }
        },
    },
    methods: {
        on_ok() {
            if (this.callback) {
                this.callback(this.source_info, this.promote_source_info);
            }
            this.on_cancel();
        },
        after_close() {
            this.source_info = undefined;
            this.promote_source_info = undefined;
        },
        on_cancel() {
            this.$emit("close");
        },
        on_click(e) {
            this.source_info = e;
        },
        on_click2(e) {
            this.promote_source_info = e;
        }
    }
};
</script>
<style lang="less" scoped>
.project {
    margin-bottom: 24px;
    &:last-child {
        margin-bottom: 0;
    }
}
.r-checkbox {
    cursor: pointer;
}
</style>